/*  This component is shared by:
 *      Fossil Free Funds
 *      Gun Free Funds
 *      Prison Free Funds
 *
 *  In the future it could be added to other screen-based sites.
 *  Weapon Free Funds has a version of this.
 *  Gender Equality Funds would need something custom.
 */
import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import {TwitterButton} from 'react-social'
import Styles from './Tweeter.css'

@CSSModules(Styles)
export default class Tweeter extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
  }

  getFundUrl(shareclass){
    const safeTicker = shareclass.ticker || 'N'

    const A = `${config.domain}`
    const B = `${config.routes.fund}/`
    const C = `${format.sanitize(shareclass.fund_legal_name)}/`
    const D = `${safeTicker}/`
    const E = `${config.profilePath}/`
    const F = `${shareclass.fund_id}/`
    const G = `${shareclass.investment_vehicle_id}/`

    return `${A}${B}${C}${D}${E}${F}${G}`
  }

  getFamilyUrl(family){
    const safeName = encodeURIComponent(family.fund_family_label || 'ERR')

    const A = `${config.domain}`
    const B = `${config.routes.families}?q=`
    const C = `${safeName}`

    return `${A}${B}${C}`
  }

  getTickerHashtag(shareclass){
    return !shareclass.ticker || ['N', 'N/A'].includes(shareclass.ticker) ?
        '' :
        ' $' + shareclass.ticker
  }

  getResultsConfig(){
    const rc = { 'xHandle': 'AsYouSow' }
    switch(config.app.title) {
      case 'Fossil Free Funds':
        rc.issueLabel = 'fossil fuel stocks'
        rc.fundAssets = 'c2f5coogutasset'
        rc.fundPerc = 'c2f5coogutweight'
        rc.fundCount = 'c2f5coogutcount'
        rc.famAssets = 'ff_all_asset_sum'
        rc.famPerc = 'ff_all_weight_total'
        rc.xHandle = 'FossilFreeFunds'
        break
      case 'Gun Free Funds':
        rc.issueLabel = 'gun manufacturer and major gun retailer stocks'
        rc.fundAssets = 'wff_civ_asset'
        rc.fundPerc = 'wff_civ_weight'
        rc.fundCount = 'wff_civ_count'
        rc.famAssets = 'wff_civ_asset_sum'
        rc.famPerc = 'wff_civ_weight_total'
        break
      case 'Prison Free Funds':
        rc.issueLabel = 'companies with prison involvement'
        rc.fundAssets = 'pff_all_asset'
        rc.fundPerc = 'pff_all_weight'
        rc.fundCount = 'pff_all_count'
        rc.famAssets = 'pff_all_asset_sum'
        rc.famPerc = 'pff_all_weight_total'
        break
    }
    return rc
  }

  render() {
    const type = this.props.type
    const item = this.props.item
    const rc = this.getResultsConfig()
    let tweetUrl = ''
    let tweetText = ''
    let assets = null
    let perc = null
    let count = 0
    let ticker = null

    //
    //
    // if family
    if (type === 'family'){
      tweetUrl = this.getFamilyUrl(item)

      const lbl = item.fund_family_label || 'ERR'

      assets = format.money(item[rc.famAssets], true, 'US Dollar', false)
      perc = format.perc(item[rc.famPerc], 0)
      count = item.num_equity_funds
      const pluralFund = count > 1 ? 's' : ''

      tweetText = `${lbl} is ${perc} (${assets}) invested in ${rc.issueLabel} across ${count} equity fund${pluralFund}`
    //
    //
    // if fund
    } else if (type === 'fund'){
      tweetUrl = this.getFundUrl(item)
      ticker = this.getTickerHashtag(item)

      assets = format.money(item[rc.fundAssets], true, 'US Dollar', false)
      perc = format.perc(item[rc.fundPerc], 0)
      count = convert.int(item[rc.fundCount])

      //
      // if dirty
      if (count > 0){
        tweetText = `${item.fund_legal_name}${ticker} is ${perc} (${assets}) invested in ${rc.issueLabel}`
      //
      // if clean
      } else {
        tweetText = `No ${rc.issueLabel} found in ${item.fund_legal_name}${ticker}`
      }
    }

    return (
      <div styleName='tweet-wrap'>
        <div styleName='tweet-text'>{tweetText}</div>
        <TwitterButton
          title='Share via Twitter'
          message={tweetText}
          url={tweetUrl + ' via @' + rc.xHandle}
          element='a'
          styleName='tweet-send'>
          Tweet&nbsp;<i className="fa fa-twitter" styleName='social-icon-twitter'/>
        </TwitterButton>
      </div>
    )
  }
}

